import React from 'react';
import PropTypes from 'prop-types';

const StepConfig = ({
  formData,
  updateFormData
}) => {
  return (
    <div className="wizard-step">
      <div className="step-intro">
        <h3>Additional Configuration</h3>
        <p>All fields are optional. AI can fill them later if needed.</p>
      </div>

      <div className="config-fields">
        <div className="form-group">
          <label htmlFor="output_constraints" className="form-label">
            Output Constraints
            <span className="label-optional">(Optional)</span>
          </label>
          <textarea
            id="output_constraints"
            value={formData.output_constraints}
            onChange={(e) => updateFormData('output_constraints', e.target.value)}
            placeholder="e.g., Professional tone, 200-500 words, proper email format"
            className="form-textarea"
            rows={3}
          />
          <span className="field-hint">Format, length, and style requirements</span>
        </div>

        <div className="form-group">
          <label htmlFor="must_include" className="form-label">
            Must Include
            <span className="label-optional">(Optional)</span>
          </label>
          <textarea
            id="must_include"
            value={formData.must_include}
            onChange={(e) => updateFormData('must_include', e.target.value)}
            placeholder="e.g., Greeting, clear subject line, body paragraphs, closing signature"
            className="form-textarea"
            rows={3}
          />
          <span className="field-hint">Elements that output must contain</span>
        </div>

        <div className="form-group">
          <label htmlFor="must_avoid" className="form-label">
            Must Avoid
            <span className="label-optional">(Optional)</span>
          </label>
          <textarea
            id="must_avoid"
            value={formData.must_avoid}
            onChange={(e) => updateFormData('must_avoid', e.target.value)}
            placeholder="e.g., Slang, informal language, emojis"
            className="form-textarea"
            rows={3}
          />
          <span className="field-hint">Things to avoid in output</span>
        </div>

        <div className="form-group">
          <label htmlFor="special_instructions" className="form-label">
            Special Instructions
            <span className="label-optional">(Optional)</span>
          </label>
          <textarea
            id="special_instructions"
            value={formData.special_instructions}
            onChange={(e) => updateFormData('special_instructions', e.target.value)}
            placeholder="e.g., Always maintain respectful and empathetic tone"
            className="form-textarea"
            rows={3}
          />
          <span className="field-hint">Any special handling requirements</span>
        </div>
      </div>
    </div>
  );
};

StepConfig.propTypes = {
  formData: PropTypes.object.isRequired,
  updateFormData: PropTypes.func.isRequired,
};

export default StepConfig;

